module.exports = __webpack_public_path__ + "img/addToHome.237f80fe.png";